const BuyTickets = ({ className }) => (
  <HyperLink
    href="http://buddiesinbadtimes.com/show/pomegranate/"
    className={className}
  >
    <span className="sr-only">Buy Tickets</span>
    <div aria-hidden="true" className="flex justify-center items-end ph3 lh-solid">
      <div style={{ fontSize: `.5rem` }}>
        <div>B</div>
        <div>U</div>
        <div>Y</div>
      </div>
      <div className="f3">&nbsp;Tickets</div>
    </div>
  </HyperLink>
)

export default BuyTickets

import React from 'react'
import HyperLink from './base/HyperLink'



// WEBPACK FOOTER //
// ./src/components/BuyTickets.js